import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

const data = [  {
    cIcon: <span className="font-bold text-5xl">1</span>,
    cIconColor: "text-[#4949DE]",
    title: "Upload photos",
    description: "Upload the student photos. You can use old photos or new ones."
  },{
    cIcon: <span className="font-bold text-5xl">2</span>,
    cIconColor: "text-[#4949DE]",
    title: "AI fixes photos",
    description: "Our AI improves the  resolution and quality of images. It also fixes backgrounds."
  },{
    cIcon: <span className="font-bold text-5xl">3</span>,
    cIconColor: "text-[#4949DE]",
    title: "Generate cards",
    description: "Each card gets a unique QR code. Cards are ready to print or use digitally."
  }];


export default function IdCardHowItWorks() {

    return (
        <Box
            badge={"Process"}
            title={"How It Works"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {data.slice(0, 3).map((member, index) => <MarktingCard key={"IdCardHowItWorks" + index} member={member} />)}
                    </div>
                </div>
            }
            rightBlock={data.slice(3).map((member, index) => <MarktingCard key={"IdCardHowItWorks" + index} member={member} />)}
        />
    );
}